import { SelectablePanel } from '@app/components/base/selectable-panel';
import { ConnectionDisplayName } from '@app/modules/social-export/components/ConnectionDisplayName';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Avatar, Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { connectionsManageMessages as messages } from './connections-manage-messages';

type Props = {
  connection: SocialExportGetConnectionStateDto;
  selected: boolean;
  onSelect: (connectionId: string) => void;
};

/**
 * Selectable list item for a client-owned social connection.
 */
export function ConnectionListItem({ connection, selected, onSelect }: Props) {
  const { $t } = useIntl();
  const { profile } = connection;
  const linkedStationsCount = connection.stationIds.length;
  const hasLinkedStations = linkedStationsCount > 0;

  return (
    <SelectablePanel selected={selected} onClick={() => onSelect(connection.id)}>
      <Avatar src={profile.photo || undefined} sx={{ width: 40, height: 40 }}>
        {(connection.name || profile.displayName)?.charAt(0) || '?'}
      </Avatar>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <ConnectionDisplayName
          connection={connection}
          variant="subtitle2"
          noWrap
          color="text.primary"
        />
        <Typography
          variant="body2"
          color={hasLinkedStations ? 'text.secondary' : 'warning.main'}
          noWrap
        >
          {$t(messages.linkedStationsCount, {
            count: linkedStationsCount,
          })}
        </Typography>
      </Box>
    </SelectablePanel>
  );
}
